import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { Size } from '../../../../Enums/Size.enum';
import EducationMaterialLibrary from '../../../../Components/EducationMaterial/EducationMaterialLibrary';
import HealthPlanBabyEducationMaterialsCustomHeader from './HealthPlanBabyEducationMaterialsCustomHeader/HealthPlanBabyEducationMaterialsCustomHeader';
import useHealthPlan from '../../Hooks/useHealthPlan';
import HealthPlanDiabetesEducationMaterialsCustomHeader from './HealthPlanDiabetesEducationMaterialsCustomHeader/HealthPlanDiabetesEducationMaterialsCustomHeader';

interface HealthPlanEducationMaterialsModalProps {
	opened: boolean;
	onClose: any;
	patientId?: string;
	disableSubmit?: boolean;
}

const HealthPlanEducationMaterialsModal: React.FC<
	HealthPlanEducationMaterialsModalProps
> = ({ opened, onClose, patientId, disableSubmit }) => {
	const { isBaby, isDiabetes } = useHealthPlan();
	const { isCase } = useTreatmentContext();

	let CustomHeaderComponent = undefined;

	if (isBaby) {
		CustomHeaderComponent = HealthPlanBabyEducationMaterialsCustomHeader;
	}

	if (isDiabetes) {
		CustomHeaderComponent = HealthPlanDiabetesEducationMaterialsCustomHeader;
	}

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.XL}>
			<Modal.Header title={'base.shared.educationMaterials'} />
			<Modal.Content contentScroll={true}>
				<EducationMaterialLibrary
					onSuccess={onClose}
					savingButton={!disableSubmit}
					patientId={patientId}
					CustomHeaderComponent={CustomHeaderComponent}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default HealthPlanEducationMaterialsModal;
